import { toast } from "react-toastify";
import AxiosInstance, { baseURL } from "../utils/AxiosInstance";
import moment from "moment-timezone";
export const GetFunction = async (Url) => {
  const token = localStorage.getItem("auth_token_nurse");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await AxiosInstance.get(
      Url,
      // Url + "?" + "page=" + page + "&" + "limit=" + limit,
      config
    );
    if (res.status == 200) {
      return res;
    }
  } catch (error) {
    toast.dismiss();

    return toast.error(
      error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.message
    );
  }
};

export const SchoolSchedule = async (
  Url,
  page = 1,
  limit = 10,
  id,
  type = "taken"
) => {
  const token = localStorage.getItem("auth_token_nurse");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await AxiosInstance.get(
      Url +
        "?" +
        "page=" +
        page +
        "&" +
        "limit=" +
        limit +
        "&" +
        "school=" +
        id +
        "&" +
        "type=" +
        type,
      config
    );
    if (res.status == 200) {
      return res;
    }
  } catch (error) {
    toast.dismiss();
    return toast.error(
      error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.message
    );
  }
};
export const GetStarGallery = async (
  Url,
  page = 1,
  limit = 10,
  type = "both"
) => {
  const token = localStorage.getItem("auth_token_nurse");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await AxiosInstance.get(
      Url +
        "?" +
        "page=" +
        page +
        "&" +
        "limit=" +
        limit +
        "&" +
        "type=" +
        type,
      config
    );
    if (res.status == 200) {
      return res;
    }
  } catch (error) {
    return toast.error(error.message);
  }
};

export const GetDataWithPostCall = async (Url, data) => {
  const token = localStorage.getItem("auth_token_nurse");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await AxiosInstance.post(Url, data, config);
    if (res.status == 200) {
      return res;
    }
  } catch (error) {
    return toast.error(error.message);
  }
};

export const ImageBaseUrl = baseURL + "/star-backend";
// export const ImageBaseUrl = "https://stars-ai.com:4000/star-backend";
export const handleimageUrl = (url) => {
  return url != undefined
    ? url?.startsWith("http") || url?.startsWith("https")
      ? url
      : ImageBaseUrl + "/" + url
    : "";
};

export const DownloadGloabal = async (url, filename) => {
  const imageUrl = handleimageUrl(url); // Replace with your image URL

  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    toast.error("something went wrong");
    console.error("Error downloading file:", error);
  }
};

export const SubmitResponse = async (URL, values = {}) => {
  const token = localStorage.getItem("auth_token_nurse");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await AxiosInstance.post(URL, values, config);
    if (res.status == 200) {
      return res;
    }
  } catch (error) {
    return toast.error(
      error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.message
    );
  }
};

export const UpdateReponse = async (URL, values) => {
  const token = localStorage.getItem("auth_token_nurse");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await AxiosInstance.patch(URL, values, config);
    if (res.status == 200) {
      return res;
    }
  } catch (error) {
    return toast.error(
      error.response.data.message ? error.response.data.message : error.message
    );
  }
};

export const UpdatePutReponse = async (URL, values) => {
  const token = localStorage.getItem("auth_token_nurse");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await AxiosInstance.put(URL, values, config);
    if (res.status == 200) {
      return res;
    }
  } catch (error) {
    return toast.error(
      error.response.data.message ? error.response.data.message : error.message
    );
  }
};
export const DeleteData = async (URL) => {
  const token = localStorage.getItem("auth_token_nurse");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await AxiosInstance.delete(URL, config);
    if (res.status == 200) {
      return res;
    }
  } catch (error) {
    return toast.error(
      error.response.data.message ? error.response.data.message : error.message
    );
  }
};

export const handleTextToSpeech = (text) => {
  const speech = new SpeechSynthesisUtterance(text);
  speech.lang = localStorage?.getItem("lang");
  window.speechSynthesis.speak(speech);
};

export const convertDate = (date) => {
  const targetTimeZone = "Asia/Kolkata"; // Replace with your desired time zone

  const dateTime = moment.tz(date, targetTimeZone);

  const utcDateTime = dateTime.utc();

  // Format hours and minutes as "10:00" format
  const formattedTime = utcDateTime.format("hh:mm A");
  return formattedTime;
};

export const convertDateAwreness = (date) => {
  const targetTimeZone = "Asia/Kolkata"; // Replace with your desired time zone

  const dateTime = moment.tz(date, targetTimeZone);

  const utcDateTime = dateTime.utc();

  // Format hours and minutes as "10:00" format
  const formattedTime = utcDateTime.format("HH:mm");
  return formattedTime;
};

export function capitalizeFirstLetter(str) {
  return str
    ?.split(" ")
    ?.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    ?.join(" ");
}
